import { ArticlePreview } from "./articles";
import { cleanObj } from "./utils";
import type { PortableTextBlock } from "@portabletext/types";

const url = "/api/v1/authors";

export type Author = {
  _id: string;
  aboutMe: PortableTextBlock[];
  alt: string;
  articles: ArticlePreview[];
  credentials: string;
  descriptionShort: string;
  educationLong: PortableTextBlock[];
  educationShort: string;
  expertiseLong: PortableTextBlock[];
  expertiseShort: string;
  hasBioPage: boolean;
  highlights: PortableTextBlock[];
  imgSrc: string;
  name: string;
  metaDescription: string;
  metaTitle: string;
  quote: string;
  slug: string;
};

export interface AuthorsShowParams {
  draft?: boolean;
  slug: string;
}

export const authorsShowQuery = ({ slug, ...params }: AuthorsShowParams) => ({
  url: `${url}/${slug}`,
  method: "GET",
  params: cleanObj(params),
});
